import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import usePDPPhotos from 'data-hooks/usePDPPhotos/index';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import { FABRIC_PRODUCT_OPTION_ID, LEATHER_PRODUCT_OPTION_ID, orientationOptionIds } from 'commons/constants';
import useRemoveBrokenImageUrls from 'global-state/brokenImageUrls/useRemoveBrokenImageUrls';
import usePDPDeepLinkVariantMismatch from 'components/consumer/PDP/hooks/usePDPDeepLinkVariantMismatch';
import PDPDesktopHeroGalleryUI from './PDPDesktopHeroGalleryUI';
const EMPTY_ARRAY = [];
const PDPDesktopHeroGallery = t0 => {
  const $ = _c(79);
  const {
    isEditOrder: t1,
    mainPhotoLink,
    mode: t2,
    pdpIsModularBYOProduct,
    slug,
    productHeroImage: t3,
    productCylindoHeroImage: t4
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const productHeroImage = t3 === undefined ? null : t3;
  const productCylindoHeroImage = t4 === undefined ? null : t4;
  const {
    loading,
    error,
    data,
    actions
  } = usePDPPhotos(null, slug);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const t5 = !pdpIsModularBYOProduct;
  let t6;
  if ($[0] !== t5) {
    t6 = {
      skip: t5
    };
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let modularPhotosData = useModularPDPPhotos(null, slug, t6);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const {
    resetGalleryImageTracking,
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  const {
    data: t7
  } = usePDPOptions();
  const {
    selectedOptionsExtended
  } = t7 === undefined ? {} : t7;
  const t8 = mode === "pdp";
  let t9;
  if ($[2] !== t8) {
    t9 = {
      isPDPDesktop: true,
      deferCylindoFetch: t8
    };
    $[2] = t8;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const {
    cylindoFeatures,
    isCylindoAvailable,
    cylindoConfigurationPhotos,
    isMechanicalOpen,
    toggleMechanicalOpen,
    isCylindoConfigurationPhotos,
    dimensionShotUrls,
    currentDimensionShot,
    selectedDimensionShotIndex,
    shouldShowDimensionThumbnail,
    setSelectedDimensionShotIndex
  } = usePDPCylindoViewer(t9);
  let t10;
  if ($[4] !== data || $[5] !== modularPhotosData?.data || $[6] !== pdpIsModularBYOProduct) {
    t10 = pdpIsModularBYOProduct ? modularPhotosData?.data ?? {} : data;
    $[4] = data;
    $[5] = modularPhotosData?.data;
    $[6] = pdpIsModularBYOProduct;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const {
    campaign,
    configurationPhotos: nonCylindoConfigurationPhotos,
    dimensionalImage,
    enableCrops,
    introVideoIds,
    isConfigFlipped,
    isVideoSelected,
    productName,
    selectedPhoto,
    studioPhotos: allStudioPhotos
  } = t10;
  const configurationPhotos = useRemoveBrokenImageUrls(isCylindoConfigurationPhotos ? cylindoConfigurationPhotos : nonCylindoConfigurationPhotos);
  const studioPhotos = useRemoveBrokenImageUrls(allStudioPhotos);
  let t11;
  if ($[8] !== actions || $[9] !== modularPhotosData?.actions || $[10] !== pdpIsModularBYOProduct) {
    t11 = pdpIsModularBYOProduct ? modularPhotosData?.actions ?? {} : actions;
    $[8] = actions;
    $[9] = modularPhotosData?.actions;
    $[10] = pdpIsModularBYOProduct;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const {
    setSelectedPhoto,
    setIsVideoSelected
  } = t11;
  const t12 = productCylindoHeroImage?.defaultUpholsteryValue;
  const t13 = productCylindoHeroImage?.defaultOrientation;
  let t14;
  if ($[12] !== t12 || $[13] !== t13) {
    t14 = {
      defaultUpholsteryValue: t12,
      defaultOrientation: t13
    };
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const isUrlDeepLinkMismatch = usePDPDeepLinkVariantMismatch(t14);
  let t15;
  bb0: {
    if (isUrlDeepLinkMismatch) {
      t15 = true;
      break bb0;
    }
    if (!productCylindoHeroImage?.src) {
      t15 = false;
      break bb0;
    }
    const norm = _temp;
    const selectedUpholstery = selectedOptionsExtended?.[FABRIC_PRODUCT_OPTION_ID]?.value || selectedOptionsExtended?.[LEATHER_PRODUCT_OPTION_ID]?.value || null;
    const selectedSku = selectedUpholstery?.sku != null ? String(selectedUpholstery.sku) : null;
    const defaultSku = productCylindoHeroImage.defaultUpholsterySku != null ? String(productCylindoHeroImage.defaultUpholsterySku) : null;
    const upholsteryMatches = selectedSku && defaultSku ? selectedSku === defaultSku : norm(selectedUpholstery?.value) === norm(productCylindoHeroImage.defaultUpholsteryValue);
    const selectedOrientationId = orientationOptionIds.find(id => selectedOptionsExtended?.[id]);
    const selectedOrientation = selectedOrientationId ? selectedOptionsExtended?.[selectedOrientationId]?.value?.value : null;
    const orientationMatches = norm(selectedOrientation) === norm(productCylindoHeroImage.defaultOrientation);
    t15 = !(upholsteryMatches && orientationMatches);
  }
  const isNonDefaultCylindoVariant = t15;
  let t16;
  bb1: {
    if (selectedPhoto?.type === "dimensional") {
      if (currentDimensionShot) {
        let t17;
        if ($[15] !== currentDimensionShot.dimensionCode || $[16] !== currentDimensionShot.src || $[17] !== selectedPhoto) {
          t17 = {
            ...selectedPhoto,
            src: currentDimensionShot.src,
            dimensionCode: currentDimensionShot.dimensionCode
          };
          $[15] = currentDimensionShot.dimensionCode;
          $[16] = currentDimensionShot.src;
          $[17] = selectedPhoto;
          $[18] = t17;
        } else {
          t17 = $[18];
        }
        t16 = t17;
        break bb1;
      }
      if (dimensionalImage?.src) {
        let t17;
        if ($[19] !== dimensionalImage.src || $[20] !== selectedPhoto) {
          t17 = {
            ...selectedPhoto,
            src: dimensionalImage.src
          };
          $[19] = dimensionalImage.src;
          $[20] = selectedPhoto;
          $[21] = t17;
        } else {
          t17 = $[21];
        }
        t16 = t17;
        break bb1;
      }
      t16 = selectedPhoto;
      break bb1;
    }
    if (isCylindoConfigurationPhotos && selectedPhoto?.type === "cylindo") {
      t16 = selectedPhoto;
      break bb1;
    }
    if (productCylindoHeroImage?.src && !isNonDefaultCylindoVariant && !isCylindoConfigurationPhotos && selectedPhoto?.type !== "studio") {
      let t17;
      if ($[22] !== productCylindoHeroImage.src) {
        t17 = {
          type: "cylindo",
          id: productCylindoHeroImage.src,
          src: productCylindoHeroImage.src
        };
        $[22] = productCylindoHeroImage.src;
        $[23] = t17;
      } else {
        t17 = $[23];
      }
      t16 = t17;
      break bb1;
    }
    if (isCylindoAvailable && !selectedPhoto) {
      if (isCylindoConfigurationPhotos) {
        t16 = cylindoConfigurationPhotos[0];
        break bb1;
      }
      let t17;
      if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = {
          type: "cylindo"
        };
        $[24] = t17;
      } else {
        t17 = $[24];
      }
      t16 = t17;
      break bb1;
    }
    const resolved = selectedPhoto || studioPhotos[0];
    if (resolved?.src || resolved?.type === "dimensional" || resolved?.type === "cylindo") {
      t16 = resolved;
      break bb1;
    }
    if (productHeroImage?.src) {
      let t17;
      if ($[25] !== productHeroImage.src) {
        t17 = {
          type: "studio",
          id: productHeroImage.src,
          src: productHeroImage.src
        };
        $[25] = productHeroImage.src;
        $[26] = t17;
      } else {
        t17 = $[26];
      }
      t16 = t17;
      break bb1;
    }
    t16 = resolved;
  }
  const selectedPhotoToShow = t16;
  let t17;
  if ($[27] !== dimensionShotUrls || $[28] !== dimensionalImage || $[29] !== selectedPhoto?.type) {
    t17 = () => {
      if (dimensionShotUrls.length) {
        return dimensionShotUrls;
      }
      if (selectedPhoto?.type === "dimensional" && dimensionalImage?.src) {
        return [{
          src: dimensionalImage.src,
          dimensionCode: "static",
          id: "static-dimensional"
        }];
      }
      return EMPTY_ARRAY;
    };
    $[27] = dimensionShotUrls;
    $[28] = dimensionalImage;
    $[29] = selectedPhoto?.type;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  selectedPhoto?.type;
  let t18;
  if ($[31] !== t17) {
    t18 = t17();
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  const dimensionShotsToShow = t18;
  const showCylindoSsrHero = !isNonDefaultCylindoVariant && !!productCylindoHeroImage?.src;
  const ssrHeroSrc = showCylindoSsrHero ? productCylindoHeroImage.src : !isUrlDeepLinkMismatch && productHeroImage?.src || null;
  const hasPhotos = !!studioPhotos?.length || !!configurationPhotos?.length;
  if (loading && !ssrHeroSrc && !hasPhotos) {
    const t19 = pdpSelectedCustomizerTab === "decide-later";
    let t20;
    if ($[33] !== mode || $[34] !== t19) {
      t20 = <PDPDesktopHeroGalleryUI loading={true} mode={mode} showDecideLaterOverlay={t19} />;
      $[33] = mode;
      $[34] = t19;
      $[35] = t20;
    } else {
      t20 = $[35];
    }
    return t20;
  }
  if (!data) {
    if (ssrHeroSrc) {
      const t19 = showCylindoSsrHero ? "cylindo" : "studio";
      let t20;
      if ($[36] !== ssrHeroSrc || $[37] !== t19) {
        t20 = {
          type: t19,
          id: ssrHeroSrc,
          src: ssrHeroSrc
        };
        $[36] = ssrHeroSrc;
        $[37] = t19;
        $[38] = t20;
      } else {
        t20 = $[38];
      }
      const t21 = pdpSelectedCustomizerTab === "decide-later";
      let t22;
      if ($[39] !== isEditOrder || $[40] !== mode || $[41] !== pdpIsModularBYOProduct || $[42] !== t20 || $[43] !== t21) {
        t22 = <PDPDesktopHeroGalleryUI selectedPhoto={t20} loading={false} mode={mode} showDecideLaterOverlay={t21} pdpIsModularBYOProduct={pdpIsModularBYOProduct} isEditOrder={isEditOrder} />;
        $[39] = isEditOrder;
        $[40] = mode;
        $[41] = pdpIsModularBYOProduct;
        $[42] = t20;
        $[43] = t21;
        $[44] = t22;
      } else {
        t22 = $[44];
      }
      return t22;
    }
    return null;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  const t19 = pdpSelectedCustomizerTab === "decide-later";
  let t20;
  if ($[45] !== cylindoConfigurationPhotos || $[46] !== setSelectedPhoto) {
    t20 = t21 => {
      const {
        id: id_0,
        index,
        src,
        type
      } = t21;
      if (type === "cylindo") {
        setSelectedPhoto?.(cylindoConfigurationPhotos[index] ?? null);
        return;
      }
      setSelectedPhoto?.({
        id: id_0,
        index,
        src,
        type
      });
    };
    $[45] = cylindoConfigurationPhotos;
    $[46] = setSelectedPhoto;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  const t21 = !isCylindoAvailable;
  let t22;
  if ($[48] !== campaign || $[49] !== configurationPhotos || $[50] !== cylindoFeatures || $[51] !== dimensionShotUrls || $[52] !== dimensionShotsToShow || $[53] !== dimensionalImage || $[54] !== enableCrops || $[55] !== introVideoIds || $[56] !== isConfigFlipped || $[57] !== isCylindoAvailable || $[58] !== isCylindoConfigurationPhotos || $[59] !== isEditOrder || $[60] !== isMechanicalOpen || $[61] !== isVideoSelected || $[62] !== mainPhotoLink || $[63] !== mode || $[64] !== pdpIsModularBYOProduct || $[65] !== productName || $[66] !== resetGalleryImageTracking || $[67] !== selectedDimensionShotIndex || $[68] !== selectedPhotoToShow || $[69] !== setIsVideoSelected || $[70] !== setSelectedDimensionShotIndex || $[71] !== shouldShowDimensionThumbnail || $[72] !== studioPhotos || $[73] !== t19 || $[74] !== t20 || $[75] !== t21 || $[76] !== toggleMechanicalOpen || $[77] !== viewGalleryImageEvent) {
    t22 = <PDPDesktopHeroGalleryUI configurationPhotos={configurationPhotos} isMechanicalOpen={isMechanicalOpen} toggleMechanicalOpen={toggleMechanicalOpen} selectedPhoto={selectedPhotoToShow} dimensionsImage={dimensionalImage} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} isEditOrder={isEditOrder} enableCrops={enableCrops} loading={false} showDecideLaterOverlay={t19} setSelectedPhoto={t20} dimensionShotUrls={dimensionShotUrls} dimensionShotsToShow={dimensionShotsToShow} selectedDimensionShotIndex={selectedDimensionShotIndex} setSelectedDimensionShotIndex={setSelectedDimensionShotIndex} studioPhotos={studioPhotos} isConfigFlipped={isConfigFlipped} introVideoIds={introVideoIds} isVideoSelected={isVideoSelected} setIsVideoSelected={setIsVideoSelected} productName={productName} cylindoFeatures={cylindoFeatures} isCylindoAvailable={isCylindoAvailable} isCylindoConfigurationPhotos={isCylindoConfigurationPhotos} resetGalleryImageTracking={resetGalleryImageTracking} viewGalleryImageEvent={viewGalleryImageEvent} pdpIsModularBYOProduct={pdpIsModularBYOProduct} mode={mode} mainPhotoLink={mainPhotoLink} campaign={campaign} displayOnlyConfigImages={t21} />;
    $[48] = campaign;
    $[49] = configurationPhotos;
    $[50] = cylindoFeatures;
    $[51] = dimensionShotUrls;
    $[52] = dimensionShotsToShow;
    $[53] = dimensionalImage;
    $[54] = enableCrops;
    $[55] = introVideoIds;
    $[56] = isConfigFlipped;
    $[57] = isCylindoAvailable;
    $[58] = isCylindoConfigurationPhotos;
    $[59] = isEditOrder;
    $[60] = isMechanicalOpen;
    $[61] = isVideoSelected;
    $[62] = mainPhotoLink;
    $[63] = mode;
    $[64] = pdpIsModularBYOProduct;
    $[65] = productName;
    $[66] = resetGalleryImageTracking;
    $[67] = selectedDimensionShotIndex;
    $[68] = selectedPhotoToShow;
    $[69] = setIsVideoSelected;
    $[70] = setSelectedDimensionShotIndex;
    $[71] = shouldShowDimensionThumbnail;
    $[72] = studioPhotos;
    $[73] = t19;
    $[74] = t20;
    $[75] = t21;
    $[76] = toggleMechanicalOpen;
    $[77] = viewGalleryImageEvent;
    $[78] = t22;
  } else {
    t22 = $[78];
  }
  return t22;
};
PDPDesktopHeroGallery.propTypes = {
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  mainPhotoLink: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string,
    // The default selection this frame represents, so the gallery can confirm the current
    // (URL/user) selection still matches before painting it as the SSR LCP (CON-8293).
    defaultUpholsteryValue: PropTypes.string,
    defaultUpholsterySku: PropTypes.string,
    defaultOrientation: PropTypes.string
  })
};
export default PDPDesktopHeroGallery;
function _temp(value) {
  return value == null ? null : String(value).trim().toLowerCase();
}